export default '0.0.2-beta3';